import React, {useEffect, useState} from 'react'
import {useTheme} from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import CardFechaM from "./componenters/card_fecha_m";
import {Box, Grid, Paper, Typography, Button} from "@mui/material";
import {ResponseProximasCarrerasIds} from "../../interfaces/priximas_carreras.interface";
import {getCarreras} from "../../services/hipodromo";
import Loading from "../../componetes/loading";
import {useAuth} from "../../context/Login.context";
import TopStatsMobile from "./componenters/tops";
import { useNavigate, useParams, useLocation } from 'react-router-dom';

interface ItemConFecha {
    fecha: string;
    ids: number[];
}

function ordenarPorFechaAcendente(lista: ItemConFecha[]): ItemConFecha[] {
    return [...lista].sort((a, b) => {
        return new Date(a.fecha).getTime() - new Date(b.fecha).getTime();
    });
}

const Hipodromo: React.FC = () => {
    const theme = useTheme();
    const auth = useAuth()
    const navigate = useNavigate();
    const location = useLocation();
    const { hipodromoId } = useParams<{ hipodromoId: string }>();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    const [list, setList] = useState<ResponseProximasCarrerasIds[] | undefined>(undefined)
    
    // Derivar estado de la URL
    const queryParams = new URLSearchParams(location.search);
    const showTops = queryParams.get('view') === 'tops';

    useEffect(() => {
        const controller = new AbortController()
        const ids = async () => {
            await auth.checkAuth()
            // Si no hay hipodromoId, por defecto 1 (Hipódromo Chile)
            const id = hipodromoId ? Number(hipodromoId) : 1;
            const data = await getCarreras(id)
            setList(data)
        }
        ids()
        return () => {
            controller.abort();
        };
        // eslint-disable-next-line
    }, [hipodromoId])

    const handleToggleView = () => {
        const currentId = hipodromoId || '1';
        if (showTops) {
            navigate(`/hipodromo/${currentId}`);
        } else {
            navigate(`/hipodromo/${currentId}?view=tops`);
        }
    };

    return (
        <Box sx={{ pb: 4 }}>
            <Paper
                elevation={0}
                sx={{
                    p: 2,
                    mb: 2,
                    marginTop: 5,
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center'
                }}
            >
                <Typography variant="h6">
                    {showTops ? '🏆 Tops del Año' : '📅 Próximas Carreras'}
                </Typography>
                <Button
                    id="hipodromo-toggle-view"
                    variant="contained"
                    onClick={handleToggleView}
                    sx={{
                        minWidth: 'auto',
                        px: 2
                    }}
                >
                    {showTops ? '📅 Ver Carreras' : '🏆 Ver Tops'}
                </Button>
            </Paper>

            {showTops ? (
                <Paper elevation={0} sx={{ p: 2 }}>
                    <TopStatsMobile hipodromoId={Number(hipodromoId || 1)} />
                </Paper>
            ) : (
                <Paper elevation={0} sx={{ p: 2, marginTop: 5, }}>
                    <Grid container spacing={2} sx={{
                        justifyContent: 'center',
                        alignItems: 'center'
                    }} id="hipodromo-races-list">
                        {list ? 
                            ordenarPorFechaAcendente(list).map((value, index) => {
                                const firstRaceId = value.ids.length > 0 ? value.ids[0] : null;
                                return (
                                <Grid key={value.fecha} item xs={isMobile ? 11 : 5}>
                                    <CardFechaM 
                                        index={index} 
                                        fecha={value.fecha} 
                                        onClick={() => {
                                            if (firstRaceId) {
                                                const currentId = hipodromoId || '1';
                                                navigate(`/hipodromo/${currentId}/carrera/${firstRaceId}`);
                                            }
                                        }}
                                    />
                                </Grid>
                            )}) : <Loading/>
                        }
                    </Grid>
                </Paper>
            )}
        </Box>
    );
}

export default Hipodromo;